import {Axios} from '../axios/axios.js'
//wage driver list
export const getWageDriverList = (e) => {
  return Axios({
    url:"/task/get_wage_worker_drop_list",
    method:'put',
    data:e
  })
}
///task/get_wage_list
export const getWageLsit = (e) => {
  return Axios({
    url:"/task/get_wage_list",
    method:'put',
    data:e
  })
}
//update_wage
export const updateWageLsit = (e) => {
  return Axios({
    url:"/task/update_wage",
    method:'put',
    data:e
  })
}
//task/upload_wage
export const uploadWage = (e) => {
  return Axios({
    url:"/task/upload_wage",
    method:'put',
    data:e
  })
}
//下载 /task/expore_wage_tasks
export const exportWageTasks = (e) => {
  return Axios({
    url:"/task/expore_wage_tasks",
    method:'put',
    data:e
  })
}
